import axios from 'axios'
import { showSuccess, showError } from '../../index.js'
import router from '@/router'
import DOMPurify from 'dompurify'
export default {
  namespaced: true,
  state () {
    return {
      homeNews: [],
      news: [],
      regularNews: [],
      backendNewsData: [],
      newsDetails: [],
      totalNews: 0,
      blankNewsData: {
        id: 0,
        title: '',
        summary: '',
        description: 'Typing description ...',
        menuId: 0
      }
    }
  },
  getters: {
    backendNews (state) {
      return state.news
    },
    frontendHomeNews (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.homeNews.filter(item => item.category === 'regular' && item.lang === 'vn').slice(0, 2)
      } else {
        return state.homeNews.filter(item => item.category === 'regular' && item.lang === 'en').slice(0, 2)
      }
    },
    // return Home-about pictures
    getHomeMainNews (state, getters, rootState) {
      const data = state.homeNews.filter(item => item.category === 'main' && item.lang === rootState.lang)
        .map(item => ({ id: item.id, path: item.img, hidden: item.hidden, url: item.url, title: item.title, summary: item.summary }))
        .reverse()
      return data
    },
    // backendDynamicNews (state) {
    //   return state.news.filter(item => item.category === 'dynamic' && item.lang === 'vn')
    // },
    // backendRegularNews (state) {
    //   return state.news.filter(item => item.category === 'regular' && item.lang === 'vn')
    // },
    // backendMainNews (state) {
    //   return state.news.filter(item => item.category === 'main' && item.lang === 'vn')
    // },
    getBackendNewsData (state) {
      return state.backendNewsData.filter(item => item.lang === 'vn')
    },
    vnBackendNewsTab: (state) => (url) => {
      const data = state.backendNewsData.find(item => item.url === url && item.lang === 'vn')
      if (!data) {
        return state.blankNewsData
      }
      return data
    },
    enBackendNewsTab: (state) => (url) => {
      const data = state.backendNewsData.find(item => item.url === url && item.lang === 'en')
      if (!data) {
        return state.blankNewsData
      }
      return data
    },
    finalNews (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.news.filter(item => item.lang === 'vn' && item.category === 'regular')
      } else {
        return state.news.filter(item => item.lang === 'en' && item.category === 'regular')
      }
    },
    findNews: (state, getters, rootState) => (url) => {
      if (rootState.lang === 'vn') {
        const data = state.news.filter(item => item.lang === 'vn' && item.hidden === false)
        return data.find(item => item.url === url)
      } else {
        const data = state.news.filter(item => item.lang === 'en' && item.hidden === false)
        return data.find(item => item.url === url)
      }
    },
    topNews (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.news.filter(item => item.lang === 'vn' && item.hidden === false && item.category === 'regular').slice(0, 2)
      } else {
        return state.news.filter(item => item.lang === 'en' && item.hidden === false && item.category === 'regular').slice(0, 2)
      }
    },
    searchSectionNews (state, getters, rootState) {
      return state.news.filter(item => item.category !== 'dynamic' && item.lang === rootState.lang && item.hidden === false)
    },
    getTotalNews (state) {
      return Math.ceil(state.totalNews / 6)
    },
    getRegularNewsByPage (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.regularNews.filter(item => item.lang === 'vn')
      } else {
        return state.regularNews.filter(item => item.lang === 'en')
      }
    },
    getNewsDetail (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.newsDetails.find(item => item.lang === 'vn' && item.hidden === false)
      } else {
        return state.newsDetails.find(item => item.lang === 'en' && item.hidden === false)
      }
    }
  },
  mutations: {
    setNews (state, payload) {
      state.news = payload
    },
    setRegularNews (state, payload) {
      state.regularNews = payload
    },
    setBackendNews (state, payload) {
      state.backendNewsData = payload
    },
    setTotalNews (state, payload) {
      state.totalNews = payload
    },
    setHomeNews (state, payload) {
      state.homeNews = payload
    },
    setNewsDetail (state, payload) {
      state.newsDetails = payload
    }
  },
  actions: {
    async getTotalRegularNews (context) {
      await axios.get(context.rootState.API_Url + 'News/GetTotalItems').then((response) => {
        const responseData = response.data
        context.commit('setTotalNews', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getNewsByPage (context, { pageNumber = 1 }) {
      await axios.get(context.rootState.API_Url + 'News/GetNewsByPage', {
        params: {
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data
        context.commit('setRegularNews', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getNewsDetailByUrl (context, payload) {
      await axios.get(context.rootState.API_Url + `News/${payload}`).then((response) => {
        const responseData = response.data
        context.commit('setNewsDetail', responseData)
      }).catch(() => {
        router.push('/no-info')
      })
    },
    async getNewsByFilters (context, { filterQuery }) {
      await axios.get(context.rootState.API_Url + 'News/GetNewsByFilter', {
        params: {
          filterQuery: filterQuery,
          lang: context.rootState.lang
        }
      }).then((response) => {
        const responseData = response.data.map(item => ({
          ...item,
          description: DOMPurify.sanitize(item.description)
        }))
        context.commit('setNews', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    // async getNewsData (context) {
    //   await axios.get(context.rootState.API_Url + 'News').then((response) => {
    //     const responseData = response.data
    //     context.commit('setNews', responseData)
    //   }).catch((error) => {
    //     console.error('There was an error!', error)
    //   })
    // },
    async getHomeNewsData (context) {
      await axios.get(context.rootState.API_Url + 'News/GetHomeNews').then((response) => {
        const responseData = response.data
        context.commit('setHomeNews', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postNews (context, payload) {
      await context.rootState.authAxios.post('/News/', {
        title: payload.title,
        img: payload.img,
        url: payload.url,
        summary: payload.summary,
        description: payload.description,
        menuId: payload.menuId,
        hidden: payload.hidden,
        category: payload.category,
        lang: payload.lang,
        date: payload.date
      })
    },
    async updateNews (context, payload) {
      await context.rootState.authAxios.put(`/News/${payload.id}`, {
        title: payload.title,
        img: payload.img,
        url: payload.url,
        summary: payload.summary,
        description: payload.description,
        menuId: payload.menuId,
        hidden: payload.hidden,
        category: payload.category,
        lang: payload.lang,
        date: payload.date
      })
    },
    async deleteNews (context, payload) {
      await context.rootState.authAxios.delete(`/News/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async changeStatusNews (context, payload) {
      await context.rootState.authAxios.put(`/News/ChangeStatus/${payload}`
      ).then(() => {
        showSuccess('Change status successfully')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async getEnNewsAdminData (context, { url }) {
      /* eslint-disable */
      let data = null

      // await axios.get(context.rootState.API_Url + 'News/GetEngData'
      await context.rootState.authAxios.get('/News/GetEngData', {
        params: {
          url: url
        }
      }).then((response) => {
        data = response.data
        data.description = DOMPurify.sanitize(data.description)
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })

      if (!data) {
        return context.state.blankNewsData
      }
      return data 
    },
    // async getRegularNewsData (context) {
    //   await axios.get(context.rootState.API_Url + 'News/GetAllRegularNews').then((response) => {
    //     const responseData = response.data
    //     context.commit('setBackendNews', responseData)
    //   }).catch((error) => {
    //     console.error('There was an error!', error)
    //   })
    // },
    async getRegularNewsByPageWithFilter (context, { filteredTerm, pageNumber = 1 }) {
      /* eslint-disable */
      let totalForPage = 1

      // await axios.get(context.rootState.API_Url + 'News/GetRNewsByPageWithFilterAdmin'
      await context.rootState.authAxios.get('/News/GetRNewsByPageWithFilterAdmin', {
        params: {
          filteredTerm: filteredTerm,
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data.paginatedData
        totalForPage = Math.ceil(response.data.totalRecords / 6)
        context.commit('setBackendNews', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })

      return totalForPage
    },
    async getMainNewsData (context) {
      // await axios.get(context.rootState.API_Url + 'News/GetAllMainNews')
      await context.rootState.authAxios.get('/News/GetAllMainNews').then((response) => {
        const responseData = response.data.map(item => ({
                  ...item,
                  description: DOMPurify.sanitize(item.description)
                }))
        context.commit('setBackendNews', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    // async getDynamicNewsData (context) {
    //   await axios.get(context.rootState.API_Url + 'News/GetAllDynamicNews').then((response) => {
    //     const responseData = response.data
    //     context.commit('setBackendNews', responseData)
    //   }).catch((error) => {
    //     console.error('There was an error!', error)
    //   })
    // }
    async getDynamicNewsByPageWithFilter (context, { filteredTerm, pageNumber = 1 }) {
      /* eslint-disable */
      let totalForPage = 1

      // await axios.get(context.rootState.API_Url + 'News/GetDNewsByPageWithFilterAdmin', {
      await context.rootState.authAxios.get('/News/GetDNewsByPageWithFilterAdmin', {
        params: {
          filteredTerm: filteredTerm,
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data.paginatedData
        totalForPage = Math.ceil(response.data.totalRecords / 10)
        context.commit('setBackendNews', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })

      return totalForPage
    },
    async getCustomerNewsByPageWithFilter (context, { filteredTerm, pageNumber = 1 }) {
      /* eslint-disable */
      let totalForPage = 1

      // await axios.get(context.rootState.API_Url + 'News/GetCNewsByPageWithFilterAdmin', {
      await context.rootState.authAxios.get('/News/GetCNewsByPageWithFilterAdmin', {
        params: {
          filteredTerm: filteredTerm,
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data.paginatedData.map(item => ({
          ...item,
          description: DOMPurify.sanitize(item.description)
        }))
        totalForPage = Math.ceil(response.data.totalRecords / 10)
        context.commit('setBackendNews', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })

      return totalForPage
    }
  }
}
